import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageIntro from "@/components/PageIntro";
import { FEATURES, FeatureRow } from "@/components/sections/Features";
import { Reveal } from "@/lib/motion";

const GROUPS = [
  { name: "Organisation", lead: "Gruppen anlegen, Aufgaben verteilen, Packliste führen – die Basis jeder Festivalplanung." },
  { name: "Kommunikation", lead: "Alle Absprachen an einem Ort, statt verstreut über Chats und Notizen." },
  { name: "Unterwegs", lead: "Anreise, Sitzplätze und Treffpunkte vor Ort gemeinsam im Blick." },
  { name: "Finanzen", lead: "Gemeinsame Ausgaben fair aufteilen – ohne Excel und Nachrechnen." },
];

export default function FeaturesPage() {
  return (
    <div data-testid="features-page">
      <PageIntro
        eyebrow="Features"
        title="Alles, was eure Crew braucht."
        lead="Sechs Werkzeuge, die WhatsApp-Gruppen, Excel-Listen und Zettelchaos ersetzen – übersichtlich nach Einsatzbereich sortiert."
      />

      <section data-testid="features-section" className="border-b border-white/10">
        <div className="mx-auto max-w-6xl px-5 pb-20 lg:px-8 lg:pb-24">
          {GROUPS.map((g, gi) => {
            const items = FEATURES.map((f, i) => ({ ...f, index: i })).filter((f) => f.group === g.name);
            return (
              <Reveal key={g.name} delay={gi * 0.03}>
                <div
                  data-testid={`feature-group-${g.name.toLowerCase()}`}
                  className="grid grid-cols-1 gap-6 border-b border-white/10 py-12 last:border-b-0 lg:grid-cols-[1fr_1.6fr] lg:gap-20"
                >
                  <div>
                    <h2 className="font-display text-2xl font-semibold text-white">{g.name}</h2>
                    <p className="mt-2 max-w-sm text-sm leading-relaxed text-white/55">{g.lead}</p>
                  </div>
                  <div className="divide-y divide-white/10">
                    {items.map((f) => <FeatureRow key={f.title} {...f} />)}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section data-testid="features-cta" className="border-y border-white/10">
        <div className="mx-auto flex max-w-6xl flex-col items-start gap-6 px-5 py-14 sm:flex-row sm:items-center sm:justify-between lg:px-8">
          <div>
            <h2 className="font-display text-2xl font-semibold text-white">Bereit für das nächste Festival?</h2>
            <p className="mt-2 text-sm text-white/55">FestivalPlan ist kostenlos für Android und iOS verfügbar – im Google Play Store und im Apple App Store.</p>
          </div>
          <Link to="/download" data-testid="features-download-link" className="btn-primary group inline-flex items-center gap-2 px-6 py-3 text-sm font-medium">
            Zum Download
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </section>
    </div>
  );
}
